module.exports = __webpack_public_path__ + "static/media/investor_approved_img.c07ba3cb.svg";